import React, {
    useEffect,
    useRef,
    useCallback,
    useState,
    useImperativeHandle
} from 'react';

// hooks
import { useRedux } from '../../../hooks/index';

// hooks
/* import { useProfile } from '../../../hooks'; */
import { createSelector } from 'reselect';
// components
import AppSimpleBar from '../../../components/AppSimpleBar';
import Loader from '../../../components/Loader';
import Message from './Message';
// import Day from "./Day";

// interface
import { MessagesTypes } from '../../../data/messages';
import ForwardModal from '../../../components/ForwardModal';

// actions
import {
    forwardMessage,
    deleteImage,
    updateCurrentPageUserMessages,
    getChatUserMessages
} from '../../../redux/actions';

// contants & enums
import { MESSAGE_TYPES } from '../../../constants';
import config from '../../../config';
interface ConversationProps {
    chatUserMessages: any;
    chatUserDetails: any;
    onDelete: (messageId: string | number) => any;
    onSetReplyData: (reply: null | MessagesTypes | undefined) => void;
    isChannel: boolean;
}
const Conversation = React.forwardRef(
    (
        {
            chatUserDetails,
            chatUserMessages,
            onDelete,
            onSetReplyData,
            isChannel
        }: ConversationProps,
        ref: React.ForwardedRef<any>
    ) => {
        // global store
        const { dispatch, useAppSelector } = useRedux();

        /* const { userProfile } = useProfile(); */

        const errorData = createSelector(
            (state: any) => state.Chats,
            (state) => ({
                getUserConversationsLoading: state.getUserConversationsLoading,
                isMessageForwarded: state.isMessageForwarded,
                hasMoreUserMessages: state.hasMoreUserMessages,
                currentPageUserMessages: state.currentPageUserMessages,
                selectedChat: state.selectedChat
            })
        );
        // Inside your component
        const {
            getUserConversationsLoading,
            isMessageForwarded,
            hasMoreUserMessages,
            currentPageUserMessages,
            selectedChat
        } = useAppSelector(errorData);

        const messages =
            chatUserMessages && chatUserMessages.length ? chatUserMessages : [];

        const conversationIdRef = useRef<any>();
        const appSimpleBarScrollRef = useRef<any>(null);
        // Función que maneja el scroll
        const scrollToBottom = () => {
            setTimeout(() => {
                const scrollElement =
                    appSimpleBarScrollRef.current.getScrollElement();
                scrollElement.scrollTo({
                    top: scrollElement.scrollHeight
                });
            }, 100);
        };
        // Exponer la función scrollToBottom al componente padre
        useImperativeHandle(ref, () => ({
            scrollToBottom
        }));

        const scrollHeightRef = useRef<number>(0);
        const scrollElement = useCallback(() => {
            if (appSimpleBarScrollRef && appSimpleBarScrollRef.current) {
                const listEle = document.getElementById(
                    'chat-conversation-list'
                );
                let offsetHeight;
                if (listEle) {
                    offsetHeight =
                        listEle.scrollHeight -
                        (scrollHeightRef.current -
                            appSimpleBarScrollRef.current.getScrollElement()
                                .scrollTop);

                    scrollHeightRef.current = listEle.scrollHeight;
                }
                if (offsetHeight) {
                    appSimpleBarScrollRef.current
                        .getScrollElement()
                        .scrollTo({ top: offsetHeight });
                }
            }
        }, [appSimpleBarScrollRef]);

        useEffect(() => {
            if (appSimpleBarScrollRef && appSimpleBarScrollRef.current) {
                appSimpleBarScrollRef.current.recalculate();
            }
        }, []);
        useEffect(() => {
            if (chatUserMessages.length > 0) {
                scrollElement();
            }
        }, [chatUserMessages, scrollElement]);

        useEffect(() => {
            dispatch(
                getChatUserMessages(selectedChat.conversationId, {
                    page: currentPageUserMessages
                })
            );
            conversationIdRef.current = selectedChat.conversationId;
        }, [currentPageUserMessages, selectedChat.conversationId, dispatch]);

        useEffect(() => {
            let interval: any;
            interval = setInterval(() => {
                if (currentPageUserMessages === 1) {
                    dispatch(
                        getChatUserMessages(selectedChat.conversationId, {
                            page: 1
                        })
                    );
                } else {
                    dispatch(
                        getChatUserMessages(selectedChat.conversationId, {
                            page: 1,
                            chunkSize: currentPageUserMessages * 10
                        })
                    );
                }
            }, config.SET_INTERVAL_TIME);

            return () => clearInterval(interval);
        }, [dispatch, currentPageUserMessages, selectedChat]);

        /* forward message */
        const [forwardData, setForwardData] = useState<
            null | MessagesTypes | undefined
        >();
        const [isOpenForward, setIsOpenForward] = useState<boolean>(false);
        const onOpenForward = (message: MessagesTypes) => {
            setForwardData(message);
            setIsOpenForward(true);
        };
        const onCloseForward = () => {
            setIsOpenForward(false);
        };

        const onForwardMessage = (data: any) => {
            const params = {
                contacts: data.contacts,
                message: data.message,
                forwardedMessage: forwardData
            };
            dispatch(forwardMessage(params));
        };
        useEffect(() => {
            if (isMessageForwarded) {
                setIsOpenForward(false);
            }
        }, [isMessageForwarded]);

        /* image delete */
        const onDeleteImage = (
            messageId: string | number,
            imageId: string | number
        ) => {
            dispatch(deleteImage(chatUserDetails.id, messageId, imageId));
        };

        const intersectionObserver = useRef<IntersectionObserver | null>(null);
        const firstMessageElementRef = useCallback(
            (chat: any) => {
                if (getUserConversationsLoading) {
                    if (
                        selectedChat.conversationId !==
                        conversationIdRef.current
                    ) {
                        scrollToBottom();
                    }
                    return;
                }
                if (intersectionObserver.current)
                    intersectionObserver.current.disconnect();
                intersectionObserver.current = new IntersectionObserver(
                    (entries) => {
                        if (entries[0].isIntersecting && hasMoreUserMessages) {
                            dispatch(
                                updateCurrentPageUserMessages(
                                    currentPageUserMessages + 1
                                )
                            );
                        }
                    }
                );
                if (chat) intersectionObserver.current.observe(chat);
            },
            [
                getUserConversationsLoading,
                hasMoreUserMessages,
                currentPageUserMessages,
                dispatch,
                selectedChat.conversationId
            ]
        );
        return (
            <AppSimpleBar
                scrollRef={appSimpleBarScrollRef}
                className="chat-conversation p-3 p-lg-4 position-relative"
            >
                {getUserConversationsLoading && <Loader />}
                <ul
                    className="list-unstyled chat-conversation-list"
                    id="chat-conversation-list"
                >
                    {(messages || []).map(
                        (message: MessagesTypes, key: number) => {
                            /* const isFromMe =
                            message.meta.sender + '' === userProfile.uid + ''; */
                            const isFromMe =
                                message.type === MESSAGE_TYPES.OUTBOUND;
                            if (appSimpleBarScrollRef && key === 0) {
                                return (
                                    <Message
                                        message={message}
                                        key={key}
                                        chatUserDetails={chatUserDetails}
                                        onDelete={onDelete}
                                        onSetReplyData={onSetReplyData}
                                        isFromMe={isFromMe}
                                        onOpenForward={onOpenForward}
                                        isChannel={isChannel}
                                        onDeleteImage={onDeleteImage}
                                        ref={firstMessageElementRef}
                                    />
                                );
                            } else {
                                return (
                                    <Message
                                        message={message}
                                        key={key}
                                        chatUserDetails={chatUserDetails}
                                        onDelete={onDelete}
                                        onSetReplyData={onSetReplyData}
                                        isFromMe={isFromMe}
                                        onOpenForward={onOpenForward}
                                        isChannel={isChannel}
                                        onDeleteImage={onDeleteImage}
                                    />
                                );
                            }
                        }
                    )}
                    {/*  <Day /> */}
                </ul>
                {isOpenForward && (
                    <ForwardModal
                        isOpen={isOpenForward}
                        onClose={onCloseForward}
                        forwardData={forwardData}
                        chatUserDetails={chatUserDetails}
                        onForward={onForwardMessage}
                    />
                )}
            </AppSimpleBar>
        );
    }
);

export default Conversation;
